import { useCallback, useEffect, useState } from "react";
const BASEURL = process.env.REACT_APP_BASE_URL;
const useDefaultersData = ({city, toDate, fromDate, skip, limit, setTotalCount}:{city:string, toDate:string,fromDate:string, skip:number, limit:number, setTotalCount:any}) => {

  const [defaultersData, setDefaultersData] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<any>();
  // useCallback(()=>{

  // },[])
  

  useEffect(() => {
    let didCancel = false;
    setError(null);

    (async () => {
      try {
        setLoading(true);
       
        const response = await fetch(
          `${BASEURL}/v1/insights/defaulters?city=${city}&to=${toDate}&from=${fromDate}`,
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        const result = await response.json();
        // console.log("result", result);
        const propertyDDN = Object.keys(result.data.defaulterList);
        const propertiesInfo = propertyDDN.map((ddn) => {
            return  {noOfDaysWaste  : result.data.defaulterList[ddn].noOfDefaulterDays, PUDDN:result.data.defaulterList[ddn].PUDDN, ownersname:result.data.defaulterList[ddn].ownersname, contactNo:result.data.defaulterList[ddn].contactNo,wardNo:result.data.defaulterList[ddn].wardNo  };
          });
          
        // console.log("propertyDDN", propertyDDN);
        setTotalCount(propertyDDN.length)
        setDefaultersData(propertiesInfo);
        
        if (!didCancel) {
      
          didCancel =true
          }
      } catch (err) {
        setError(err);
      } finally {
        setLoading(false);
      }
    })();

    return () => {
      didCancel = true;
    };
  }, [city, toDate, fromDate]);

  return {  defaultersData, loading, error };
};

export default useDefaultersData ;
